<template>
  <div class="popup-main">
    <el-dialog
      :title="detailId ? '编辑工作地点' : '新增工作地点'"
      width="800px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <div class="m-b-10">
          <c-read-company-address @success="updateReadCompanyAddress" />
        </div>
        <div v-if="loaded">
          <div class="department-box">
            <div class="t-a-r" style="width: 240px">
              <span class="m-r-4 c-red">*</span>
              <span class="m-r-5 c-black">所属组织</span>
            </div>
            <b-organize-staff :data.sync="selfData.department_data" width="1288px" />
          </div>
          <e-form
            ref="refForm"
            :config="formConfig"
            :column="formColumn"
            :rules="formRules"
            :data.sync="selfData"
          />
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    detailId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      loaded: false,
      selfShow: false,
      selfData: {
        id: '',
        department_ids: [],
        department_data: {},
        work_name: '',
        address_area_ids: [],
        address_detail: '',
        post_code: '',
        remark: '',
        status: true
      },
      formConfig: {
        inline: false,
        width: '100%'
      },
      formColumn: [
        {
          type: 'text',
          title: '工作地点名称',
          field: 'work_name',
          required: true
        },
        {
          type: 'address',
          title: '所在地区',
          field: 'address_area_ids',
          required: true
        },
        {
          type: 'text',
          title: '详细地址',
          field: 'address_detail'
        },
        {
          type: 'number',
          title: '邮政编码',
          field: 'post_code'
        },
        {
          type: 'text',
          title: '描述',
          field: 'remark'
        },
        {
          type: 'switch',
          title: '状态',
          field: 'status'
        }
      ],
      formRules: {
        work_name: [{ required: true, message: '请输入工作地点名称' }],
        address_area_ids: [{ required: true, message: '请输入所在地区' }]
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    if (this.detailId) {
      this.getDetailData()
    } else {
      this.loaded = true
    }
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      this.loaded = false
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/work2/detail',
        params: {
          id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data.data)
          this.selfData = result
        }
      })
      this.loaded = true
    },
    // 更新识别公司地址信息
    updateReadCompanyAddress(val) {
      this.loaded = false
      this.selfData.work_name = val.work_name || val.name
      this.selfData.address_area_ids = val.address_area_ids
      this.selfData.address_detail = val.address_detail || val.address
      this.selfData.post_code = val.post_code
      this.$nextTick(() => {
        this.loaded = true
      })
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          this.$api({
            method: 'post',
            url: '/admin/gcvip/work2/saveOrUpdate',
            data: {
              form_data: {
                ...this.selfData,
                department_ids: this.selfData.department_data.department_list.map((item) => item.id)
              }
            }
          })
            .then((res) => {
              if (res.data.state === 'ok') {
                this.popupCancel()
                this.$emit('success')
                this.$message.success('保存成功')
              }
            })
            .catch((error) => {
              this.$message.error(error)
            })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  .department-box {
    position: relative;
    z-index: 99;
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
